import { BrowserRouter, Routes, Route } from "react-router-dom";
import Body from "./Components/Body/body";
import ContactUs from "./Components/ContactUsComp/contactus";
import AboutUs from "./Components/AboutUsComp/aboutus";
import Membership from "./Components/MembershipComp/membership-directory";
import Services from "./Components/ServicesComp/services";
import Footer from "./Components/FooterComp/footer";
import NewsAndEvents from "./Components/NewsandEvents/newsandevents";
import { Navbar } from "./Components/NavComp/navbar";

import SignIn from "./Components/LoginComp/signin";
import SignUp from "./Components/LoginComp/signup";
import ForgotPassword from "./Components/LoginComp/ForgotPassword";
import PrivateRoute from "./Utils/PrivateRoute"; 
import UserProfile from "./Components/UserComp/userprofile"; 
import ViewApplication from "./Components/UserComp/viewapplication"; 
import AdminPanel from "./Components/AdminComp/adminpanel"; 
import ScrollToTop from "./ScrollComp/ScrollToTop"
import MemberRegistration from "./Components/MembershipComp/registration";
import Faq from "./Components/InfomationComp/faq";
import Locations from "./Components/LocationComp/locations";
import SubAdminPanel from "./Components/SubAdminComp/sub-admin-panel";


import Feedback from "./Components/FeedBackComp/feedback";
import Supplier from "./Components/SupplierComp/supplier";



function App() {
  return (
    <BrowserRouter>
    <ScrollToTop />
    <Navbar />
      <Routes>
         {/* <Route path="/" element={<MemberRegistration />} /> */}

        <Route path="/" element={<Body />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/membership-directory" element={<Membership />} />
        <Route path="/contactus" element={<ContactUs />} />
        <Route path="/services" element={<Services />} />
        <Route path="/newsandevents" element={<NewsAndEvents /> } />
        <Route path="/signin" element={<SignIn />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/forgotpassword" element={<ForgotPassword />} />
        <Route path="/userprofile" element={<UserProfile />} />
        <Route path="/viewapplication" element={<ViewApplication />} />
        <Route path="/registration" element={<MemberRegistration />} /> 
        <Route path="/faq" element={<Faq />} /> 
        <Route path="/locations" element={<Locations />} /> 
        <Route path="/supplier" element={<Supplier />} /> 

          <Route
          path="/userprofile"
          element={
            <PrivateRoute>
                <UserProfile />
            </PrivateRoute>
          }
        />

                    
                     
        
                <Route
          path="/adminpanel"
          element={
            <PrivateRoute>
              <AdminPanel />
            </PrivateRoute>
          }
        />


                <Route
          path="/sub-admin-panel"
          element={
            <PrivateRoute>
              <SubAdminPanel />
            </PrivateRoute>
          }
        />



      </Routes>
    <Feedback />
      <Footer />
    </BrowserRouter>
  );
}

export default App;